// extracted by mini-css-extract-plugin
export default {"tasks":"bQ-z","task":"cQ-z","svg":"dQ-z","text":"eQ-z"};